import React from 'react';
import { Link } from 'gatsby';

import { formatDate, getImageUrlFromFilename } from '@vitl-services/services/format';
import { useImage } from '@hooks/useImage';

import * as styles from './blog-top-articles.module.scss';

interface IProps {
  title: string;
  image: string;
  path: string;
  datePublished?: number | null;
  author?: string;
}

const BlogTopArticles: React.FC<IProps> = ({
  title = '',
  path = '',
  image,
  datePublished = null,
  author = '',
}) => {
  const logoHeader = useImage(['logo_header.svg']);

  return (
    <div className={styles.container} data-testid="top-articles">
      <div className={styles.postPreviewRow}>
        <div className={styles.imagePreviewContent}>
          {image ? (
            <div
              className={styles.imagePreview}
              style={{
                backgroundImage: `url(${
                  getImageUrlFromFilename(image) + '?h=150'
                })`,
              }}
            ></div>
          ) : (
            <div
              className={styles.imagePreview}
              style={{
                backgroundImage: `url(${logoHeader})`,
                backgroundSize: '50%',
              }}
            ></div>
          )}
        </div>
        <div className={styles.postPreviewContent}>
          <Link className={styles.buttonLink} to={path}>
            <h2 className={styles.h2}>{title}</h2>
          </Link>
          <div className={styles.date}>
            {author && author}
            {author && datePublished ? (
              <span className={styles.dateDivider}> / </span>
            ) : (
              ''
            )}
            {datePublished && `${formatDate(datePublished)}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogTopArticles;
